export const unique = (array, prop) => {
  return array.reduce((groups, item) => {
    const val = item[prop]
    if (!groups[val]) groups[val] = item
    return groups
  }, {})
}

export const capitalize = str => {
  return str[0].toUpperCase() + str.slice(1)
}

export const fixLink = link => {
  if (link.match(/^https?:\/\//)) {
    return link
  }
  return 'http://' + link
}



// WEBPACK FOOTER //
// ./src/services/Helpers.js